import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  ProductConfiguration,
  ProductConfigurationFeature,
  ProductConfigurationOption
} from '../../models/product-configuration-types';

@Injectable({
  providedIn: 'root'
})
export class ProductConfigurationService {
  constructor(protected http: HttpClient) {}

  getOne(id: string): Observable<ProductConfiguration> {
    const url = `json/product-configurations/${id}`;
    return this.http.get<ProductConfiguration>(url);
  }

  getFeatures(ids: string[]): Observable<ProductConfigurationFeature[]> {
    const url = `json/product-configuration/features/by-ids?ids=${ids.join(',')}`;
    return this.http.get<ProductConfigurationFeature[]>(url).pipe(
      map(features => {
        // Sort features to match the order in ids
        const featureMap = new Map(features.map(f => [f.id, f]));
        return ids.map(id => featureMap.get(id)).filter(f => f !== undefined);
      })
    );
  }

  getOptions(ids: string[]): Observable<ProductConfigurationOption[]> {
    const url = `json/product-configuration/options/by-ids?ids=${ids.join(',')}`;
    return this.http.get<ProductConfigurationOption[]>(url).pipe(
      map(options => {
        // Sort options to match the order in ids
        const optionMap = new Map(options.map(o => [o.id, o]));
        return ids.map(id => optionMap.get(id)).filter(o => o !== undefined);
      })
    );
  }
}
